export default {
  name: "ZoomOut",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M18 13c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1zm11.71 16.71a.996.996 0 0 1-1.41 0l-8.26-8.26c-2.25 1.88-5.25 2.87-8.48 2.46-4.73-.61-8.62-4.34-9.4-9.05C.91 7.35 7.35.91 14.86 2.15c4.71.78 8.44 4.67 9.05 9.4.42 3.23-.58 6.23-2.46 8.48l8.26 8.26c.39.39.39 1.03 0 1.42zm-18.23-7.84c6.15 1.01 11.41-4.25 10.4-10.4-.61-3.73-3.62-6.73-7.34-7.35C8.38 3.11 3.11 8.38 4.13 14.53c.61 3.72 3.62 6.73 7.35 7.34z",
  },
}
